import {combineReducers} from "redux";

import whychooseus from "../features/admin/aboutus/whychooseus/Slice";

import whatourclientsay from "../features/admin/aboutus/whatourclientsay/Slice";

import testimonial from "../features/admin/aboutus/testimonial/Slice";

import common from "../features/admin/common/Slice";

const aboutus = combineReducers({    
    whychooseus,    
    whatourclientsay,
    testimonial,    
    common
});

export default aboutus;